<template>
	<a :href="property.slug" class="fair property">
    <div class="property-image">
      <img src="@/assets/img/franquias/rent-img.jpg" alt="" />
    </div>
    <div class="property-content">
      <span class="property-type">{{ property.type }}</span>
      <div class="property-location">
        <h4>{{ property.address }}</h4>
        <span> {{ property.district }}, {{ property.city }}</span>
      </div>
      <div class="property-info">
        <span v-if="property.size" class="property-size">
          <img src="@/assets/img/franquias/icons/ruler.svg" alt="" />
          {{ property.size }} m<sup>2</sup>
        </span>
        <span v-if="property.bedrooms" class="property-bedrooms">
          <img src="@/assets/img/franquias/icons/bed.svg" alt="" />
          {{ property.bedrooms }} quarto{{ property.bedrooms > 1 ? 's' : '' }}
        </span>
        <span v-if="property.bathrooms" class="property-bathrooms">
          <img src="@/assets/img/franquias/icons/showerHead.svg" alt="" />
          {{ property.bathrooms }} banheiro{{ property.bathrooms > 1 ? 's' : '' }}
        </span>
        <span v-if="property.garage" class="property-garage">
          <img src="@/assets/img/franquias/icons/car.svg" alt="" />
          {{ property.garage }} vaga{{ property.garage > 1 ? 's' : '' }}
        </span>
        <span v-if="property.condominium" class="property-condominium">
          <img src="@/assets/img/franquias/icons/gate.svg" alt="" />
          Condomínio
        </span>
        <span v-if="property.pet" class="property-pet">
          <img src="@/assets/img/franquias/icons/pets.svg" alt="" />
          Aceita pet
        </span>
      </div>
      <div class="property-footer">
        <div class="property-price">
          <span class="property-price-old">{{ propertyOldPrice }}</span>
          <strong>{{ propertyPrice }}</strong>
        </div>
        <div class="property-price-expiry-date">
          <img src="@/assets/img/franquias/fair-expiry-date.png" alt="">
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import '@/assets/scss/custom/franquias/components/_fair-property-card.scss'


export default {
	components: {
	},
	props: {
		property: {
			type: Object,
			required: true
		}
	},
	computed: {
		propertyPrice() {
			return new Intl.NumberFormat('pt-BR', {
				style: 'currency',
				currency: 'BRL',
			}).format(this.property.price)
		},
    propertyOldPrice() {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(this.property.oldPrice)
    }
	}
}
</script>